import { Component, OnInit } from '@angular/core';
import { IHeaderGroup, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'app-header-checkbox',
  template: `
    <mat-checkbox
      class="cellcheckbox custom-mat-checkbox"
      [checked]="checked"
      color="warn"
      (change)="headerCheckChanged($event)"
    ></mat-checkbox>
  `,
  styles: [
    `
      .cellcheckbox {
        background: #fff;
        border-radius: 2px;
      }
    `,
  ],
})
export class HeaderCheckboxGroupComponent implements IHeaderGroup {
  private params: any;
  checked: boolean = false;

  agInit(params: any): void {
    this.params = params;

    const gridType = this.params.context?.gridType;

    if (gridType === 'grid1') {
      this.checked = this.params.context.componentParent.headerCheckboxChecked;
    } else if (gridType === 'grid3') {
      this.checked = this.params.context.componentParent.headerCheckboxChecked1;
    }
  }

  afterGuiAttached(params?: IAfterGuiAttachedParams): void {}

  headerCheckChanged(event: any): void {
    const gridType = this.params.context?.gridType;

    if (gridType === 'grid1') {
      this.params.context.componentParent.headerCheckChangedGrid1(event);
    } else if (gridType === 'grid3') {
      this.params.context.componentParent.headerCheckChangedGrid3(event);
    }

    this.checked = event.checked;
  }
}
